import {
  Dialog,
  DialogActions,
  DialogContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
} from "@material-ui/core";
import MuiButton from "Components/MuiButton/MuiButton";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import React, { useEffect, useState } from "react";
import Translator from "Languages/Utility/Translator";
import Grid from "@material-ui/core/Grid";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
import { useSetState } from "Helpers/Hooks";
import FactorService from "Services/http/endpoints/factor/FactorService";
import { read } from "Helpers/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import { convertGroups } from "Constants/Constants";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import StatusHandler from "Helpers/StatusHandler";
import MuiCheckBoxGroup from "Components/MuiCheckboxGroup/MuiCheckboxGroup";
import { FACTOR_RESULT } from "Stores/actionTypes";
import { ReactSVG } from "react-svg";
import Convert from "Assets/svg/icon/convert.svg";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/core/styles";
import * as Icons from "react-bootstrap-icons";

const ConvertDialog = ({ disabled }) => {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const { selectedProject, factorResult } = useSelector((state) => ({
    selectedProject: state.project.selectedProject,
    factorResult: state.factor.factorResult,
  }));
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [convertList, setConvertList] = useState([]);
  const [unitConvertInfo, setUnitConvertInfo] = useState(null);
  const [showSelect, setShowSelect] = useState(true);
  const [controls, setControls] = useSetState({
    convertGroup: {
      type: "radio",
      value: null,
      items: null,
      col: {
        sm: 12,
        xs: 12,
      },
    },
    convertProfile: {
      type: "checkbox",
      items: [
        { value: true, label: t("profiles"), key: "CheckProfile" },
        { value: false, label: t("fittings"), key: "CheckFitting" },
        { value: false, label: t("glasses"), key: "CheckGlass" },
        { value: false, label: t("nets"), key: "CheckNet" },
      ],
      col: {
        sm: 12,
        xs: 12,
      },
    },
    convertFrom: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
      col: {
        sm: 12,
        xs: 12,
      },
    },
    convertTo: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
      col: {
        sm: 12,
        xs: 12,
      },
    },
  });

  const handleDialog = () => setOpenDialog(!openDialog);

  const onEnter = async () => {
    try {
      setLoading(true);
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        ListUnitId: factorResult.ListUnitId,
        CheckAll: factorResult.CheckAll,
        IdProject: selectedProject.Id,
      };
      const response = await FactorService.postInfoUnitConvert(data);
      setUnitConvertInfo(response.data.Value);

      if (factorResult?.ParamConvert) setConvertList(factorResult.ParamConvert);

      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const onExit = () => {
    setOpenDialog(false);
    setLoading(false);
    setConvertList([]);
    setUnitConvertInfo(null);
    setShowSelect(true);
    setControls({ convertGroup: { value: null } });
    const items = [
      { value: true, label: t("profiles"), key: "CheckProfile" },
      { value: false, label: t("fittings"), key: "CheckFitting" },
      { value: false, label: t("glasses"), key: "CheckGlass" },
      { value: false, label: t("nets"), key: "CheckNet" },
    ];
    setControls({ convertProfile: { items: items } });
    setControls({ convertFrom: { value: "" } });
    setControls({ convertTo: { value: "" } });
  };

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    if (controlName === "convertFrom") {
      await getToOptions(value);
    }
  };
  
  const getToOptions = async (selectedValue) => {
    try {
      setLoading(true);
      const { Group } = selectedValue;
      let response = null;
      if (Group === 1) {
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdTemplate: selectedValue.Id,
          Type: selectedValue.TypeTemplate,
        };
        response = await FactorService.getTemplateForConvert(params);
      }
      if (Group === 2) {
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdGlass: selectedValue.Id,
        };
        response = await FactorService.getGlassForConvert(params);
      }
      if (Group === 3) {
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdNet: selectedValue.Id,
        };
        response = await FactorService.getNetForConvert(params);
      }
      if (Group === 4) {
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdPop: selectedValue.Id,
        };
        response = await FactorService.getPopForConvert(params);
      }
      if (Group === 5) {
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Id: selectedValue.Id,
        };
        response = await FactorService.getProfileForConvert(params);
      }
      if (response) {
        let err = StatusHandler(response);
        if (!err.isFail) {
          const data = response.data.Value;
          const toOptions = data.map((item) => {
            return {
              ...item,
              value: item.Id,
              label: item.Name,
            };
          });
          setControls({ convertTo: { selectItems: toOptions } });
          setControls({ convertTo: { value: toOptions[0] } });
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const onFinish = (e) => {
    e.preventDefault();
    setLoading(true);
    let update = convertList.slice();
    update = update.map((item) => {
      delete item.name;
      // delete item.from;
      // delete item.to;
      return item;
    });
    const result = {
      ...factorResult,
      ParamConvert: update,
    };
    dispatch({ type: FACTOR_RESULT, factorResult: result });
    setLoading(false);
    handleDialog();
  };

  const onChangeRadio = (name, key, value) => {
    setControls({ [name]: { value: value } });
    setControls({ convertFrom: { value: "" } });
    setControls({ convertTo: { value: "" } });
    if (value.value === 1) {
      setShowSelect(true);
    } else {
      setShowSelect(false);
    }
  };

  const onChangeCheckbox = (e, name, index) => {
    const items = controls[name].items;
    items[index] = { ...items[index], value: e.currentTarget.checked };
    setControls({ [name]: { items: items } });
  };

  const onAddToList = () => {
    setLoading(true);
    const newList = [...convertList];
    const checkboxes = controls.convertProfile.items.reduce(
      (obj, item) => ({ ...obj, [item.key]: item.value }),
      {}
    );
    const obj = {
      ...checkboxes,
      Group: controls.convertFrom.value.Group,
      IdAz: controls.convertFrom.value.value,
      IdBe: controls.convertTo.value.value,
      TypeTemplate: controls.convertFrom.value.TypeTemplate,
      name: controls.convertGroup.value.label,
      from: controls.convertFrom.value.Name,
      to: controls.convertTo.value.Name,
    };
    setControls({ convertFrom: { value: "" } });
    setControls({ convertTo: { value: "" } });
    newList.push(obj);
    setConvertList(newList);
    setLoading(false);
  };

  const onDelete = async (list) => {
    const newList = convertList.filter(
      (item) => item.IdAz !== list.IdAz && item.IdBe !== list.IdBe
    );
    setConvertList(newList);
  };
  const onGetOptionDisabled = (option, key) => {
    const list = [...convertList];
    if (key === "convertFrom") {
      return list.some((item) => item.IdAz === option.value);
    }
  };

  useEffect(() => {
    if (unitConvertInfo) {
      setLoading(true);
      const filterGroups = convertGroups.filter((item) => {
        return unitConvertInfo.some((f) => {
          return f.Group === item.value;
        });
      });
      setControls({ convertGroup: { value: filterGroups[0] } });
      setControls({ convertGroup: { items: filterGroups } });
      setLoading(false);
    }
  }, [unitConvertInfo]);

  useEffect(() => {
    (async () => {
      if (controls.convertGroup.value) {
        setLoading(true);
        const filterFrom = unitConvertInfo.filter(
          (item) => item.Group === controls.convertGroup.value?.value
        );
        const fromOptions = filterFrom.map((item) => {
          return {
            ...item,
            value: item.Id,
            label: item.Name,
          };
        });
        setControls({
          convertFrom: { selectItems: fromOptions, value: fromOptions[0] },
        });
        await getToOptions(fromOptions[0]);
        setLoading(false);
      }
    })();
  }, [controls.convertGroup]);

  return (
    <>
      <MuiButton
        color="secondary"
        title={<Translator id={"unit_convert"} />}
        onClick={handleDialog}
        disabled={disabled || factorResult.ListUnitId.length === 0}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        TransitionProps={{ onEnter: onEnter, onExit: onExit }}
        onClose={handleDialog}
        fullWidth
        maxWidth="sm"
      >
        <BackDropLoading loading={loading} />
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>
              <Translator id="unit_convert" />
            </p>
          </div>
          <DialogContent>
            <Grid container spacing={3}>
              {Object.keys(controls).map((key, index) => {
                return (
                  <Grid
                    item
                    sm={controls[key].col.sm}
                    xs={controls[key].col.xs}
                    key={key + index}
                  >
                    {controls[key].type === "radio" && controls[key].value && (
                      <MuiRadioGroup
                        label={<Translator id={key} />}
                        name={key}
                        value={controls[key].value}
                        items={controls[key].items}
                        labelKey={controls[key].labelKey}
                        valueKey={controls[key].valueKey}
                        onChange={onChangeRadio}
                        className="horizontalRadio"
                      />
                    )}
                    {showSelect && controls[key].type === "checkbox" && (
                      <MuiCheckBoxGroup
                        label={<Translator id={key} />}
                        name={key}
                        value={controls[key].value}
                        items={controls[key].items}
                        onChange={onChangeCheckbox}
                        className="horizontalCheckbox"
                      />
                    )}
                    {controls[key].type === "select" && (
                      <MuiAutoComplete
                        getOptionDisabled={(option) =>
                          onGetOptionDisabled(option, key)
                        }
                        disabled={
                          !controls.convertFrom.value.value &&
                          key === "convertTo"
                        }
                        options={controls[key].selectItems}
                        label={<Translator id={key} />}
                        value={controls[key].value}
                        id={key}
                        onChange={autoCompleteHandler}
                      />
                    )}
                  </Grid>
                );
              })}
              <Grid item xs={12} className="mb-2">
                <MuiButton
                  loading={loading}
                  disabled={!controls.convertFrom.value.value}
                  color="primary"
                  title={<Translator id="ezafe_be_list" />}
                  onClick={onAddToList}
                  className="m-0"
                />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <List dense={true}>
                {convertList.map((item, index) => {
                  return (
                    <ListItem key={`convert-list-${index + 1}`} className="convert-list">
                      <ListItemText
                        primary={
                          <>
                            <Icons.ArrowLeftRight size={15} />
                            {item.name}
                          </>
                        }
                        secondary={
                          <>
                            <span className="row-head">{"تبدیل از"}</span>
                            <span>{item.from}</span>
                            <span className="row-head">{"به"}</span>
                            <span>{item.to}</span>
                          </>
                        }
                      />
                      <ListItemSecondaryAction>
                        <MuiIconButton
                          icon={<Icons.Trash3 size={17} />}
                          className="danger-fill"
                          onClick={() => onDelete(item)}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  );
                })}
              </List>
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
              color="primary"
              type="submit"
              disabled={convertList.length === 0}
              title={<Translator id="button_save" />}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

export default ConvertDialog;
